import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/fn/array/find';
import { Provider } from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import i18n from './i18n';
import { ConnectedRouter, routerMiddleware} from 'react-router-redux';
import AppReducers from './reducers';
import logger from 'redux-logger';
import './style/index.css';
import App from './containers/AppController';
import registerServiceWorker from './registerServiceWorker';
import {setBaseUrl} from 'ith-fetch';
import history from './history';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MaterialThemeExtension from './style/material';
import 'react-sortable-tree/style.css';
// import {shouldUpdateExtend} from "ith-redux-helpers";
import 'core-js/fn/array/find';
import 'core-js/fn/array/for-each';
import 'core-js/fn/array/map';
import 'core-js/fn/object/keys';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/values';
import { composeWithDevTools } from 'redux-devtools-extension';
import {API_URL} from "./misc/vars";

const theme = getMuiTheme(lightBaseTheme, MaterialThemeExtension);

const composeEnhancers = composeWithDevTools({});//  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleWare = () => {
	if (process.env.NODE_ENV === 'production') {
		console.log = console.debug = console.info = console.warn = function(){};
		return composeEnhancers(applyMiddleware(routerMiddleWare, thunkMiddleware));
	}
	return composeEnhancers(applyMiddleware(routerMiddleWare, thunkMiddleware, logger));
};

const routerMiddleWare = routerMiddleware(history);
const store = createStore(AppReducers, middleWare());



setBaseUrl(API_URL);

i18n.on('languageChanged', lng => console.log('changes lang to:', lng));
window.store = store;
ReactDOM.render(<Provider store={store}><MuiThemeProvider muiTheme={theme}><ConnectedRouter history={history}><App/></ConnectedRouter></MuiThemeProvider></Provider>, document.getElementById('root'));
registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js